export default function isPlainObject(x) {
    return (x !== null &&
        typeof x === 'object' &&
        x.constructor.name === Object.name &&
        /* check for reasonable markers that the object isn't an element for react & preact/compat */
        !('props' in x && x.$$typeof));
}
//# sourceMappingURL=isPlainObject.js.map